import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21 3.93v13.14c0 .78-.9 1.21-1.5.73l-1.03-.83a8.5 8.5 0 0 0-1.558-1 .29.29 0 0 1-.162-.26V5.291a.29.29 0 0 1 .162-.26 8.6 8.6 0 0 0 1.558-1l1.03-.83c.6-.482 1.5-.052 1.5.728m-6.116 11.305a.293.293 0 0 0 .365-.283V6.047a.293.293 0 0 0-.366-.283A9 9 0 0 1 12.84 6H7.696C5.35 6 3.252 7.71 3.022 10.044A4.5 4.5 0 0 0 7.5 15l2.453 4.897A2 2 0 0 0 11.74 21H13l-1-6h.84a9 9 0 0 1 2.043.236"
    }, null, -1)
  ])))
}
export default { render: render }